<div class="d-flex flex-column h-100">
	<div class="d-flex flex-column flex-grow-1 align-items-center justify-content-center bg-cover-image">
		<div class="container my-4">
			<div class="row g-0">
				<div class="col-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3 shadow-lg">
					<div class="d-flex flex-column bg-secondary py-4">
						<div class="px-4 mb-3">
							<a [href]="'/'"
								[routerLink]="['/']">
								<svg-icon [class]="'hover'"
									[svgClass]="'icon--button'"
									src="assets/images/icon-arrow-left.svg"></svg-icon>
							</a>
						</div>
						<div class="d-flex flex-column my-auto">
							<div class="d-flex flex-column justify-content-center text-center">
								<svg-icon [svgClass]="'logo--text'"
									src="assets/images/ys-logo-text-reversed.svg"></svg-icon>
							</div>
						</div>
					</div>
					<div class="d-flex flex-column align-items-center bg-white">
						<div class="w-100 p-4 p-lg-5">
							<div class="fs-4 text-center">Reset Password</div>
							<hr>
							<p *ngIf="notAuthorized"
								class="text-danger">
								The password reset link has expired, please request a new one via the
								<a [href]="'/password/reset'">password reset page</a>
								.
							</p>
							<p *ngIf="oldPasswordUsed"
								class="text-danger">
								Your new password is the same as your old password. Please create a new password.
							</p>
							<p *ngIf="!hasErrors">
								Enter your new password and we'll update our records. You will then be able to log into your account.
							</p>
							<form [formGroup]="form"
								(ngSubmit)="onSubmit()"
								autocomplete="off"
								novalidate
								class="form--max-width mx-auto">
								<div class="mb-3">
									<input [ngClass]="{'is-invalid' : form.controls.password.invalid && form.controls.password.dirty}"
										type="password"
										class="form-control bordered"
										formControlName="password"
										placeholder="New password">
								</div>
								<div class="mb-3">
									<input [ngClass]="{'is-invalid' : form.controls.passwordConfirm.invalid && form.controls.passwordConfirm.dirty}"
										type="password"
										class="form-control bordered"
										formControlName="passwordConfirm"
										placeholder="Confirm new password">
									<div class="invalid-feedback">
										Passwords do not match
									</div>
								</div>
								<div class="text-center">
									<button [disabled]="form.invalid || hasErrors"
										type="submit"
										class="btn btn-primary">
										Reset password
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
